import { Link, useLocation } from 'react-router-dom'
import { 
  LayoutDashboard, 
  Users, 
  Wallet,
  History,
  ChevronLeft,
  ChevronRight,
  LogOut,
  User,
  Settings,
  Receipt,
  Shield
} from 'lucide-react'
import { useAuth } from '../contexts/AuthContext'

export default function Sidebar({ open, setOpen }) {
  const location = useLocation()
  const { user, logout } = useAuth()
  
  const isAdmin = user?.role === 'admin'

  // 導航項目
  const navigation = [
    { name: '儀表板', href: '/dashboard', icon: LayoutDashboard },
    { name: '客戶管理', href: '/customers', icon: Users },
    { name: '💰 記帳系統', href: '/expense-manager', icon: Wallet },
    { name: '💳 費用明細', href: '/expense-history', icon: History },
    { name: '📋 交易記錄', href: '/budget-transactions', icon: Receipt },
    ...(isAdmin ? [{ name: '📝 稽核日誌', href: '/audit-logs', icon: Shield }] : []),
  ]

  const handleLogout = async () => {
    if (confirm('確定要登出嗎?')) {
      await logout()
    }
  }
  
  return (
    <div className={`fixed left-0 top-0 h-full bg-white border-r border-gray-200 transition-all duration-300 ${open ? 'w-64' : 'w-20'} z-50`}>
      {/* Header */}
      <div className="flex items-center justify-between p-4 border-b border-gray-200">
        {open && (
          <h1 className="text-xl font-bold text-gray-800 truncate">
            Azure 帳單
          </h1>
        )}
        <button
          onClick={() => setOpen(!open)}
          className="p-2 rounded-lg hover:bg-gray-100 transition-colors"
        >
          {open ? (
            <ChevronLeft className="w-5 h-5 text-gray-600" />
          ) : (
            <ChevronRight className="w-5 h-5 text-gray-600" />
          )}
        </button>
      </div>
      
      {/* Navigation */}
      <nav className="p-4 space-y-2">
        {navigation.map((item) => {
          const isActive = location.pathname === item.href
          const Icon = item.icon
          
          return (
            <Link
              key={item.name}
              to={item.href}
              className={`flex items-center space-x-3 px-4 py-3 rounded-lg transition-all ${
                isActive
                  ? 'bg-primary-500 text-white shadow-lg'
                  : 'text-gray-700 hover:bg-gray-100'
              }`}
            >
              <Icon className={`w-5 h-5 flex-shrink-0 ${isActive ? 'text-white' : 'text-gray-500'}`} />
              {open && (
                <span className="font-medium truncate">{item.name}</span>
              )}
            </Link>
          )
        })}
      </nav>
      
      {/* 用戶資訊和登出 */}
      {open && (
        <div className="absolute bottom-0 left-0 right-0 border-t border-gray-200 bg-gray-50">
          <div className="p-4">
            {/* 用戶資訊 */}
            <div className="flex items-center space-x-3 mb-3">
              {user?.avatar_url ? (
                <img 
                  src={user.avatar_url} 
                  alt={user.name || '用戶'} 
                  className="w-10 h-10 rounded-full"
                />
              ) : (
                <div className="w-10 h-10 rounded-full bg-indigo-100 flex items-center justify-center">
                  <User className="w-5 h-5 text-indigo-600" />
                </div>
              )}
              <div className="flex-1 min-w-0">
                <p className="text-sm font-medium text-gray-900 truncate">
                  {user?.name || user?.email || '用戶'}
                </p>
                {user?.email && (
                  <p className="text-xs text-gray-500 truncate">
                    {user.email}
                  </p>
                )}
              </div>
            </div>
            
            {/* 設定按鈕 */}
            <Link
              to="/settings"
              className={`w-full flex items-center justify-center space-x-2 px-4 py-2 mb-2 rounded-lg transition-colors ${
                location.pathname === '/settings'
                  ? 'bg-indigo-100 text-indigo-700'
                  : 'bg-gray-100 hover:bg-gray-200 text-gray-700'
              }`}
            >
              <Settings className="w-4 h-4" />
              <span className="text-sm font-medium">系統設定</span>
            </Link>
            
            {/* 登出按鈕 */}
            <button
              onClick={handleLogout}
              className="w-full flex items-center justify-center space-x-2 px-4 py-2 bg-red-50 hover:bg-red-100 text-red-600 rounded-lg transition-colors"
            >
              <LogOut className="w-4 h-4" />
              <span className="text-sm font-medium">登出</span>
            </button>
          </div>
          
          <p className="text-xs text-gray-500 text-center py-2">
            © 2025 Azure 帳單系統
          </p>
        </div>
      )}
    </div>
  )
}
